<div *ngIf="showMe">
    <tds-modal header="Batch Job Status" show size="lg" actions-position="sticky" prevent="true" (tdsClose)="closeDialog()">
        <span slot="body">
          <tds-folder-tabs *ngIf="isSysAdmin()">
                <tds-folder-tab>
                    <button (click)="showThis('email-batch-job-status')">Email</button>
                </tds-folder-tab>
                <tds-folder-tab>
                    <button (click)="showThis('import-batch-job-status')">Import</button>
                </tds-folder-tab>
            </tds-folder-tabs>

            <div>
                <div *ngIf="visiblePage === 'email-batch-job-status' && isSysAdmin()">
                    <email-batch-job-status></email-batch-job-status>
                </div>
                <div *ngIf="visiblePage === 'import-batch-job-status' && isSysAdmin()">
                    <import-batch-job-status></import-batch-job-status>
                </div>
            </div>
            <!-- <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width *ngIf="batchJobStatusList.length > 0">
                <tds-table-header>
                    <tds-header-cell cell-key="jobType" cell-value="Batch job type"></tds-header-cell>
                    <tds-header-cell cell-key="date" cell-value="Date"></tds-header-cell>
                    <tds-header-cell cell-key="status" cell-value="Status" text-align="right"></tds-header-cell>
                </tds-table-header>
                <tds-table-body>
                    <tds-table-body-row *ngFor="let batchJob of batchJobStatusList">
                        <tds-body-cell
                          cell-key="jobType"
                          disable-padding="false">
                              {{ batchJob.batchJobType }}
                        </tds-body-cell>
                        <tds-body-cell
                          cell-key="date"
                          disable-padding="false">
                              {{ batchJob.date }}
                        </tds-body-cell>
                        <tds-body-cell
                          cell-key="status"
                          disable-padding="false"
                          text-align="right">
                              <tds-icon style="color: var(--tds-positive)" *ngIf="batchJob.status" name="tick" size="32px" svg-title="Batch job succeeded"></tds-icon>
                              <tds-icon style="color: var(--tds-negative);" *ngIf="!batchJob.status" name="cross" size="32px" svg-title="Batch job failed"></tds-icon>
                        </tds-body-cell>
                    </tds-table-body-row>
                </tds-table-body>
            </tds-table> -->
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                text="Close"
                size="md"
                variant="primary">
            </tds-button>
        </span>
    </tds-modal>
</div>